"use strict";
import { rQuad } from './rquad.js';
import { r_pictures } from './rpic';
import axios from 'axios';
import {rTComment} from "../rikis"

/**
 * Loads the shader files
 * @param {type} vpath
 * @param {type} fpath
 * @param {type} gpath
 * @returns {undefined}
 */
function loadShadersAndGo(canvasID, imageUrl, wid = 700, hgt = -1, dimx = 20, dimy = 10, duration = 120) {

	var vertexShaderSource;
	var fragmentShaderSource;

	//riferimento al Quad reperibile ovunque!
	var quad = window.rQuad = window.parent.window.rQuad = Object.create(rQuad);


	//	loader.style.display = "block";


	var imur = imageUrl;
	//	

	//SLIKA!
	//	imur="/uploads/high/DSC00824.jpg.jpg";
	//
	//	alert("mona");
	//

	//		imur = "/images/tester2.png";
	//		wid = 30;
	//		hgt = 30;
	//		dimx = 20;
	//		dimy = 10;

	//	if (imageUrl != undefined) {
	//		imur = decodeURI(imageUrl); //remeber to parseInt!!!
	//	}
	//

	//    bench();
	//    playSound();

	/**L'url base di questa animazione' */
	let baseurlo = "/js/pic04";

	let vpath = baseurlo + "/shaders/shader.vert";
	let fpath = baseurlo + "/shaders/shader.frag";

	axios.get(vpath)
		.then(function(resp) {
			//carichiamo il vertex shader
			vertexShaderSource = resp.data;
			//                if (rTComment)  console.log(vertexShaderSource);
			axios.get(fpath)
				.then(function(resp) {

					//carichiamo il fragment shader
					fragmentShaderSource = resp.data;

					//inizializzazione oggetto con i parametri in entrata!
					quad.setSourcesAndInit(canvasID, imur, vertexShaderSource, fragmentShaderSource,
						parseInt(wid), parseInt(hgt), parseInt(dimx), parseInt(dimy), parseFloat(duration));

				})
				.catch(function(resp) {
					if (rTComment) console.log(resp);
					alert("Could not load Image: " + resp);
				});
		})
		.catch(function(resp) {
			if (rTComment) console.log(resp);
			alert("Could not load file: " + fpath);
		});

}


/**CHIMIAMO FUNZIONE DI SERVIZIO */
//servizio();
//throw "klinco";


//recuperiamo la stringa get che sarà l'indirizzo dell'immagine
//var rpic = "/uploads/high/DSC00824.jpg";
//var wid = get('wid');
//var hgt = get('hgt');
//var dimx = get('dimx');
//var dimy = get('dimy');
//var duration = get('dur');
//if (rpic == 'undefined' || rpic == '') rpic = 'DSC00911.jpg';
//

var rpic = "/uploads/high/DSC00870.jpg";
//var rpic = "/images/tester1.png";
//var rpic = "/images/verapika1.jpg";
var wid = 500;
var hgt = -1;
var dimx = 20;
var dimy = -1;
var duration = 300;
//if (rpic == 'undefined' || rpic == '') rpic = 'DSC00911.jpg';

//if (rTComment)  console.log('bo kaj?');
//bench();

//facciamo partire lo script per il GLES!!
loadShadersAndGo('can1', rpic, wid, hgt, dimx, dimy, duration);


function playSound() {

	var ac = new AudioContext();
	var osc = ac.createOscillator();

	//    var real = new Float32Array([0.7, .5, .3, .6, 1, .2, .5]);
	//    var imag = new Float32Array([.3, .5, .3, 0, 1, 1, .5]);
	var real = new Float32Array([0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]);
	//    var imag = new Float32Array([0.0, 0.0]);
	var imag = new Float32Array(real.length);
	var wave = ac.createPeriodicWave(real, imag, { disableNormalization: true });

	osc.setPeriodicWave(wave);

	osc.connect(ac.destination);

	osc.start();
	osc.stop(8);


}

/**
recupera dall'url il parametro get indicato!!
 */
function get(name) {
	if (name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(location.search))
		return decodeURIComponent(name[1]);
}


/**funzioe di servizio, solo per sperimentare robe facilmente */
function servizio() {

	//	let p = .20; //il beat che vogliamo mantenere 
	//
	//	let N = 200; //la distanza che ci interessa
	//
	//	let i = 0; //posizione vera
	//
	//	let K = N / p; //nemro totale di 
	//
	//	let x = 0;

	for (let i = 0; i < numInstruments.length; i++) {
		if (rTComment) console.log('bound ' + i, getInstrumentBoundary(i));
	}


	//	let scatterFloorTime = function(time, beatunit = 1, beat = .01) {
	//		let t=beat * beatunit;
	//		return Math.floor((time / t)) * t;
	//	}
	//	/**La funzione ritorna la posizione del tempo posizionata per beats. EG. se il beat è .2 adesso 1.1234 diventa 1.0,  */
	//	let scatterCeilTime = function(time, beatunit = 1, beat = .01) {
	//		let t=beat * beatunit;
	//		return Math.ceil((time / t)) * t;
	//	}
	//
	//	for (i = 30; i < N; i += .009) {
	//
	//		x = Math.floor(i * (K / N));
	//		x = Math.floor(i / p);
	//
	//		let z = scatterFloorTime(i, 3, 0.20);
	//		let c= scatterCeilTime(i, 3, 0.20);
	//
	//		if (rTComment)  console.log('servizio i ', i.toFixed(3), 'x',x.toFixed(3), 'x*p',(x * p).toFixed(3), 'floor',z.toFixed(3), 'ceil',c.toFixed(3));
	//
	//
	//
	//	}
	//
	//	throw "klinco";

}

/**Benchmark vari */
function bench() {
	let N = 100000000;
	let a = [N];
	let b = [];
	let c = [];
	let d = {};

	let t = 0;
	let z = 0;
	let f = 1.1;

	let cl = { ena: 1.1, dva: 1.1, tri: 1.1 };
	let ca = [1.1, 1.1, 1.1];


	t = performance.now();
	for (let i = 0; i < N; i++) {
		z = 0;
		z = cl.ena;
		z = cl.dva;
		z = cl.tri;
	}
	if (rTComment) console.log("Timing: reading class variable : " + (performance.now() - t));

	t = performance.now();
	for (let i = 0; i < N; i++) {
		z = 0;
		z = ca[0];
		z = ca[1];
		z = ca[2];
	}
	if (rTComment) console.log("Timing: reading array variable : " + (performance.now() - t));

	t = performance.now();
	for (let i = 0; i < N; i++) {
		z = 0;
		z = f;
		z = f;
		z = f;
	}
	if (rTComment) console.log("Timing: reading variable : " + (performance.now() - t));


	//	throw 'kgb';


	t = performance.now();
	for (let i = 0; i < N; i++) {
		a[i] = i;
	}
	if (rTComment) console.log("Timing: array construction - a[N]: " + (performance.now() - t));

	t = performance.now();
	for (let i = 0; i < N; i++) {
		b[i] = i;
	}
	if (rTComment) console.log("Timing: array construction - b[]: " + (performance.now() - t));

	t = performance.now();
	for (let i = 0; i < N; i++) {
		c.push(i);
	}
	if (rTComment) console.log("Timing: array construction - c.push: " + (performance.now() - t));



	t = performance.now();
	z = 0;
	for (let i = 0; i < N; i++) {
		z = a[i];
	}
	if (rTComment) console.log("Timing: array seek - a[N]: " + (performance.now() - t));

	t = performance.now();
	z = 0;
	for (let i = 0; i < N; i++) {
		z = b[i];
	}
	if (rTComment) console.log("Timing: array seek - b[]: " + (performance.now() - t));

	t = performance.now();
	z = 0;
	for (let i = 0; i < N; i++) {
		z = c[i];
	}
	if (rTComment) console.log("Timing: array seek - c.push: " + (performance.now() - t));


}

export { loadShadersAndGo, r_pictures, bench };